import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useEffect } from 'react';
import { licitaciones2018 } from '../../json/licitaciones2018';
import { licitaciones2019 } from '../../json/licitaciones2019';
import { licitaciones2020 } from '../../json/licitaciones2020';
import { licitaciones2021 } from '../../json/licitaciones2021';
import { licitaciones2022 } from '../../json/licitaciones2022';
import { licitaciones2023 } from '../../json/licitaciones2023';
import { licitaciones2024 } from '../../json/licitaciones2024';
import { licitaciones2025 } from '../../json/licitaciones2025';
import { licitaciones2026 } from '../../json/licitaciones2026';
//import { licitaciones2027 } from '../../json/licitaciones2027';
//import { licitaciones2028 } from '../../json/licitaciones2028';
//import { licitaciones2029 } from '../../json/licitaciones2029';
//import { licitaciones2030 } from '../../json/licitaciones2030';
import Licitaciones2018 from '../Licitaciones2018/Licitaciones2018';


const LicitacionesAnteriores = () => {
  
  const  { ciclo }  = useParams();
  
  const [
    licitaciones, setLicitaciones
  ] = useState ( [] );

  const selLicitaciones = async () => {     
    switch (ciclo) {
      case '2018':
        setLicitaciones (licitaciones2018)
        break
      case '2019':
        setLicitaciones (licitaciones2019)
        break
      case '2020':
        setLicitaciones (licitaciones2020)
        break
      case '2021':
        setLicitaciones (licitaciones2021)
        break 
      case '2022':
        setLicitaciones (licitaciones2022)
        break
      case '2023':
        setLicitaciones (licitaciones2023)
        break
      case '2024':
        setLicitaciones (licitaciones2024)
        break
      case '2025':
        setLicitaciones (licitaciones2025)
        break
      case '2026':
        setLicitaciones (licitaciones2026)
            }
    }

  useEffect(() => {
    selLicitaciones();
    window.scrollTo(0, 0);

  }, [ ciclo ]);

    return(        
        <>            
            <br />
            <Licitaciones2018 ciclo={ciclo} licitaciones={ licitaciones } />
            
        </>
    )
}

export default LicitacionesAnteriores